module.exports = __webpack_public_path__ + "img/conference.5c8b5b1e.jpg";